import React from 'react'
import Element from 'layouts/Element'

export default class Section extends Element {
  static get defaultProps () {
    return {}
  }

  get defaultClassNames () {
    return ['content-section']
  }

  render () {
    return (
      <div className={this.classNames}>
        {this.props.children}
      </div>
    )
  }
}
